import { useEffect, useState } from "react";
import { ImageUploadIcon, ShareIcon } from "components/atoms/Icon";
import InputFieldWithLabel from "components/molecules/forms/InputFieldWithLabel";
import TextAreaWithLabel from "components/molecules/forms/TextAreaWithLabel";
import { useFormContext } from "react-hook-form";
import DatePickerInput from "components/atoms/forms/DatePickerInput";
import BigImageUpload from "components/atoms/UploadImage";
import moment from "moment";
import CheckboxWithLabel from "components/molecules/forms/CheckboxWithLabel";

function ClaimCodeForm() {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    getValues,
  } = useFormContext<ShareRequestCreateFormData | ShareRequestEditFormData>();

  const [isStartTimePickerModalOpen, setisStartTimePickerModalOpen] = useState(false);
  const [isExpirationDatePickerModalOpen, setIsExpirationDatePickerModalOpen] = useState(false);

  const thumbnailUrl = getValues("thumbnail_url");

  const handleSetStartDateTime = (value: moment.Moment | null) => {
    if (value) setValue("start_time", value, { shouldValidate: true });
  };
  const handleSetEndDateTime = (value: moment.Moment | null) => {
    if (value) setValue("end_time", value, { shouldValidate: true });
  };

  useEffect(() => {
    if (errors.thumbnail) {
      setValue("thumbnail", undefined);
    }
  }, [errors.thumbnail]);

  const handleSetThumbnailValue = (file: FileList) => {
    if (file.item(0)) {
      setValue("thumbnail", file.item(0) as File, {
        shouldValidate: true,
      });
      setValue("media_type", file.item(0)?.type || "");
    }
  };

  const handleClearThumbnail = () => {
    setValue("thumbnail", undefined);
  };

  return (
    <div className="mt-2 grid grid-cols-10 items-start gap-3 2xl:mt-4 2xl:gap-4">
      <div className="col-span-3 mt-4 aspect-1">
        <BigImageUpload
          setFieldValue={handleSetThumbnailValue}
          // @ts-ignore
          existingImageURL={thumbnailUrl}
          choosenFile={watch("thumbnail")}
          label="Drag or Drop or Browse from Local Files"
          errors={errors?.thumbnail?.message}
          labelClasses="italic text-xxs 2xl:text-xs text-white"
          id="image"
          handleClearImage={handleClearThumbnail}
          acceptVideo
          icon={<ImageUploadIcon className="h-20 w-20 2xl:h-24 2xl:w-24" />}
        />
        <div className="flex flex-col items-center space-y-1 pb-1 pt-5 text-center text-sm leading-6">
          <div className="flex items-center space-x-2">
            <ShareIcon className="h-6" />
            <p className="font-sora font-medium text-white">Upload your Media</p>
          </div>

          <p className="font-satoshi font-normal text-white">(Images, GIFs, and Short Videos are allowed)</p>
          <CheckboxWithLabel
            isChecked={watch("post_data.is_media_shared")}
            isDisabled={false}
            label="Include media in tweet"
            id="post_data.is_media_shared"
            labelClasses="text-xxs 2xl:text-xs"
            register={register}
          />
        </div>
      </div>
      <div className="col-span-7 grid grid-cols-12 gap-x-7">
        <div className="col-span-6 flex flex-col">
          <InputFieldWithLabel
            label="Share Request Title"
            id="name"
            labelClasses="text-xxs 2xl:text-xs"
            register={register}
            placeHolder="Enter the name of the Memento"
            defaultValue=""
            errorMessage={errors.name?.message as any}
          />
          <TextAreaWithLabel
            label="Instructions For Users"
            labelClasses="text-xxs 2xl:text-xs"
            id="description"
            rows={5}
            placeHolder="Enter the instructions for users regarding this Share Request"
            register={register}
            descriptionWordCount={watch("description").length}
            defaultValue=""
            errorMessage={errors.description?.message}
          />
        </div>
        <div className="col-span-6">
          <DatePickerInput
            label="Airdrop Date/Time"
            id="start_time"
            isDatePickerModalOpen={isStartTimePickerModalOpen}
            setIsDatePickerModalOpen={setisStartTimePickerModalOpen}
            startDateTime={watch("start_time")}
            minDate={new Date()}
            error={errors.start_time?.message}
            handleSetDateTimeForMomemto={handleSetStartDateTime as any}
          />
          <DatePickerInput
            label="Share Request Valid Till Date/Time"
            id="end_time"
            isDatePickerModalOpen={isExpirationDatePickerModalOpen}
            setIsDatePickerModalOpen={setIsExpirationDatePickerModalOpen}
            // @ts-ignore
            minDate={watch("start_time")}
            startDateTime={watch("end_time")}
            error={errors.end_time?.message}
            handleSetDateTimeForMomemto={handleSetEndDateTime as any}
          />
        </div>
        <div className="col-span-8">
          <TextAreaWithLabel
            label="Post Content"
            labelClasses="text-xxs 2xl:text-xs"
            id="post_data.post_content"
            rows={3}
            placeHolder="Enter the content of the tweet"
            register={register}
            descriptionWordCount={watch("post_data.post_content").length}
            defaultValue=""
            errorMessage={errors.post_data?.post_content?.message}
            maxDescriptionWordCount={180}
          />
        </div>
      </div>
    </div>
  );
}

ClaimCodeForm.propTypes = {};

export default ClaimCodeForm;
